import { connect } from 'react-redux';
import SetPassword from './setpassword';
import { resetPassword } from '../reducers/auth.reducers';

const mapStateToProps = state => ({
  errorMessage: state.authentication.errorMessage,
  loading: state.authentication.loading,
});

const mapDispatchToProps = dispatch => ({
  resetPassword: credentials => dispatch(resetPassword(credentials)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SetPassword);



// WEBPACK FOOTER //
// ./src/app/activateaccount/setpassword.container.js